import React from "react";
import PropTypes from "prop-types";
import LinkAgent from "../LinkAgent/index.js";
import Styles from "./styles.css";
var FilterActionSection = function FilterActionSection(_ref) {
  var _ref$clear_button_dis = _ref.clear_button_disabled,
    clear_button_disabled = _ref$clear_button_dis === void 0 ? true : _ref$clear_button_dis,
    _ref$apply_button_dis = _ref.apply_button_disabled,
    apply_button_disabled = _ref$apply_button_dis === void 0 ? true : _ref$apply_button_dis,
    _ref$clear_url = _ref.clear_url,
    clear_url = _ref$clear_url === void 0 ? 'javascript:void(0)' : _ref$clear_url,
    _ref$apply_url = _ref.apply_url,
    apply_url = _ref$apply_url === void 0 ? 'javascript:void(0)' : _ref$apply_url,
    applyTrackParams = _ref.applyTrackParams,
    productType = _ref.productType,
    resultsCount = _ref.resultsCount;
  var onApply = function onApply() {
    Fashion.Helpers.AnalyticsHelpers.trackFilterApplyEvent(applyTrackParams, productType);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(Styles['cta-button-row'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(Styles['cta-button'])
  }, /*#__PURE__*/React.createElement(LinkAgent, {
    linkText: "Clear",
    classes: Styles['clear-button'],
    href: clear_url,
    role: "button",
    "aria-disabled": clear_button_disabled ? true : undefined,
    disabled: clear_button_disabled
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(Styles['cta-button'])
  }, /*#__PURE__*/React.createElement(LinkAgent, {
    classes: "".concat(Styles['apply-filters-link'], " ").concat(Styles['top-filter']),
    linkText: "Apply (".concat(resultsCount, ")"),
    disabled: apply_button_disabled,
    href: apply_url,
    role: "button",
    "aria-disabled": apply_button_disabled ? true : undefined,
    color: "primary",
    onClick: onApply
  })));
};
process.env.NODE_ENV !== "production" ? FilterActionSection.propTypes = {
  clear_url: PropTypes.string,
  clear_button_disabled: PropTypes.bool,
  apply_url: PropTypes.string,
  apply_button_disabled: PropTypes.bool,
  applyTrackParams: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  resultsCount: PropTypes.number
} : void 0;
export default FilterActionSection;